export const headingFonts = {
  Omnes: 'WoltHeading-Omnes',
  October: 'WoltHeading-October',
  MPlus: 'WoltHeading-M-Plus-Rounded-1c',
} as const;

export const DATA_ATTR_THEME = 'data-cb-theme';
export const DATA_ATTR_HEADING_FONT = 'data-cb-heading-font';

export const GLOBAL_PORTAL_ELEMENT_ID = 'cb-portal';
